<template>
    <v-toolbar
      app
      color="blue darken-3"
      dark
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed>

    <v-toolbar-title>
      <v-toolbar-side-icon v-if="isAuthenticated" @click.stop="toogleDrawer"></v-toolbar-side-icon>
      Area de cliente
    </v-toolbar-title>
    
    <v-spacer></v-spacer>

    <v-select v-if="isAuthenticated" v-model="idComunidadActiva"
      :items="comunidades"
      
      item-text="NOMBRE"
      item-value="IDCOMUNIDAD"
      
      solo-inverted flat hide-details full-width>
    </v-select>  
    
  </v-toolbar>
</template>

<style>
</style>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { COMUNIDADES_ACTIVATE } from '../store/actions/comunidades'
  import { USER_TOGGLE_DRAWER } from '../store/actions/user';

  export default {
    name: 'toolbar',
    data: function () {
      return {}
    },
    methods: {
      toogleDrawer: function () {
        this.$store.dispatch(USER_TOGGLE_DRAWER)
      }
    },
    computed: {
      idComunidadActiva: {
        get() {
          return this.$store.getters.idComunidadActiva
        },
        set(value) {
          this.$store.dispatch(COMUNIDADES_ACTIVATE, value)
          this.$router.push('/home') 
        }
      },
      ...mapGetters(['isAuthenticated']),
      ...mapState({
        comunidades: state => state.comunidades.comunidades
      })
    },
  }
</script>